import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';


import { createPlugin } from '@backstage/core-plugin-api';

import {
  CBEntityPicker,
  CBEntityPickerValidation,
  CBEntityPickerSchema
} from './CBEntityPickerExtension'


import {
  MultiRelatedEntityPicker,
  validateMultiRelatedEntityPickerValidation,
} from './MultiRelatedEntityPicker' 


import {
  RelatedEntityPicker,
  validateRelatedEntityPickerValidation,
} from './RelatedEntityPicker'



export const CustomFieldsExtensionsPlugin = createPlugin({
  id: 'CustomFieldsExtensions',
  
});


export const CBEntityPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CBEntityPicker',
    component: CBEntityPicker,
    schema: CBEntityPickerSchema,
    validation: CBEntityPickerValidation,
  }),
);


export const MultiRelatedEntityPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MultiRelatedEntityPicker',
    component: MultiRelatedEntityPicker,
    validation: validateMultiRelatedEntityPickerValidation,
  }),
);



export const RelatedEntityPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RelatedEntityPicker',
    component: RelatedEntityPicker,
    validation: validateRelatedEntityPickerValidation,
  }),
);